import React from 'react';
import PropTypes from 'prop-types';
import { questionType } from '../../constants/types';
import { getTranslation } from '../../i18n';

import sharedStyles from '../../styles/shared';
import styles from './questionText.module.css';

const QuestionText = ({
  question, orderNum, lang, translate: t, id, errorId, showError = false
}) => {
  const requiredSuffix = question.required ? ` (${t('surveyParts.required', lang)})` : '';
  // make screen reader read 'question five: ' ('question 5: ') instead of 'fifth' ('5.')
  const accessibleLabel = `${t('common.question', lang)} ${orderNum}: ${getTranslation(question.text, lang)}${requiredSuffix}`;
  return (
    <div className={`${sharedStyles.question} ${styles.container}`} aria-label={accessibleLabel} id={id}>
      <div className={styles.number} aria-hidden>
        <p>{orderNum}.</p>
      </div>
      <div className={styles.text} aria-hidden>
        <p className={question.required ? styles.required : ''}>
          {getTranslation(question.text, lang)}
        </p>
      </div>
      {showError && (
      <p id={errorId} className={styles.warningText} aria-hidden>
        {t('surveyParts.isRequired')}
      </p>
      )}
    </div>
  );
};

const {
  number, string, func, bool
} = PropTypes;

QuestionText.propTypes = {
  orderNum: number.isRequired,
  question: questionType.isRequired,
  lang: string.isRequired,
  translate: func.isRequired,
  id: string.isRequired,
  errorId: string,
  showError: bool
};

QuestionText.defaultProps = {
  errorId: undefined,
  showError: false
};

export default QuestionText;
